// extracted by css-extract-rspack-plugin
var _1 = "CwUecQnaKMRProB3";
var _2 = "Uh4oZI59hmoly1II";
var _3 = "CCOhyGC3sr6sxefg";
export { _1 as "fadeIn", _2 as "fullscreen", _3 as "xs" }
